import React from 'react'
import { type To } from 'react-router'
import { Link } from 'react-router-dom'

interface Props {
  className?: string
  type?: 'button' | 'submit' | 'reset' | undefined
  children?: React.ReactNode
  href?: ''
  disabled?: boolean
  contrast?: boolean
  filled?: boolean
  large?: boolean
  transparent?: boolean
  primary?: boolean
  to?: To
  onClick?: React.MouseEventHandler<HTMLButtonElement> &
    React.MouseEventHandler<HTMLAnchorElement>
}

function BtnIcon(props: Props): React.ReactElement {
  const Tag = props.href ? 'a' : 'button'
  const type = props.href ? undefined : props.type ?? 'button'

  const modifiers = React.useMemo((): string => {
    const LIST = ['disabled', 'contrast', 'filled', 'large', 'transparent', 'primary']

    return LIST.reduce((acc: string[], item: string) => {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-expect-error
      if (props[item]) {
        acc.push(`_${item}`)
      }

      return acc
    }, []).join(' ')
  }, [props])

  if (!props.to) {
    return (
      <Tag
        className={`btn-icon ${modifiers} ${props.className ?? ''}`.trim()}
        type={type}
        onClick={props.onClick}
      >
        <span className="btn-icon__inner">{props.children}</span>
      </Tag>
    )
  } else {
    return (
      <Link
        className={`btn-icon ${modifiers} ${props.className ?? ''}`.trim()}
        to={props.to}
      >
        <span className="btn-icon__inner">{props.children}</span>
      </Link>
    )
  }
}

export default BtnIcon
